import { useState } from "react";
import styled from "styled-components";

import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useToast } from "../../../contexts/ToastContext";

const ModalTitle = styled.h3`
    margin: 0 0 18px 0;
    padding: 0 0 12px 2px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 15px;
    font-weight: 700;
    color: #263b4b;
    text-align: left;
    width: 100%;
`;

const ModalNovoProssmap = () => {

    const { closeModal } = useModal();
    const { notifyError, notifyWarning } = useToast();

    const [matricula, setMatricula] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!matricula.trim()) {
            notifyError("Informe a matrícula do encarregado.");
            return;
        }

        // TODO: integrar com a API de geração do PROSSMAP
        notifyWarning("Geração de PROSSMAP ainda não implementada.");
    };

    return (
        <Overlay state>
            <Modal header close={closeModal} size="sm">
                <ModalTitle>NOVO PROSSMAP</ModalTitle>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="MATRÍCULA DO ENCARREGADO"
                        type="numberOnly"
                        valor={matricula}
                        changeFunc={(e) => setMatricula(e.target.value)}
                        placeholder="Ex.: 123456"
                        maxLength={6}
                        required
                    />
                    <FormComp type="submit" valor="GERAR PROSSMAP" />
                </Formulario>
            </Modal>
        </Overlay>
    );
};

export default ModalNovoProssmap;
